export const common = {

  fonts: {
    body: `"Montserrat", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`,
    heading: `"Montserrat", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
    mono: `SFMono-Regular, Menlo, Monaco, Consolas, monospace`,
  },

  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "22px",
    xxl: "28px",
    hero: "48px"
  },

  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },

  lineHeights: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75
  },

  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    xxl: "48px",
    huge: "72px"
  },

  radius: {
    sm: "6px",
    md: "10px",
    lg: "16px",
    xl: "22px",
    pill: "999px"
  },

  shadow: {
    xs: "0 1px 2px rgba(0,0,0,0.05)",
    sm: "0 4px 10px rgba(0,0,0,0.08)",
    md: "0 10px 30px rgba(0,0,0,0.12)",
    lg: "0 20px 60px rgba(0,0,0,0.15)"
  },

  transition: {
    fast: "all .15s ease",
    default: "all .25s ease",
    slow: "all .4s ease"
  },

  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    laptop: "1024px",
    desktop: "1280px",
    wide: "1600px"
  },

  mq: {
    mobile: "@media (max-width:480px)",
    tablet: "@media (max-width:768px)",
    laptop: "@media (max-width:1024px)",
    desktop: "@media (max-width:1280px)"
  },

  zIndex: {
    header: 100,
    dropdown: 200,
    overlay: 300,
    modal: 9999,
    tooltip: 500
  },


  utils: {
    smartHover: (color, theme) => {
        const hex = color.replace("#", "");
        const num = parseInt(hex, 16);

        const r = (num >> 16) & 255;
        const g = (num >> 8) & 255;
        const b = num & 255;

        // Hintergrund hell oder dunkel prüfen
        const bgHex = theme.colors.background.replace("#", "");
        const bgNum = parseInt(bgHex, 16);
        const bgR = (bgNum >> 16) & 255;
        const bgG = (bgNum >> 8) & 255;
        const bgB = bgNum & 255;

        const brightness =
        (bgR * 299 + bgG * 587 + bgB * 114) / 1000;

        const amount = 25; // Stärke des Effekts

        let newR = r;
        let newG = g;
        let newB = b;

        if (brightness > 128) {
        // Light Mode → dunkler
        newR = Math.max(0, r - amount);
        newG = Math.max(0, g - amount);
        newB = Math.max(0, b - amount);
        } else {
        // Dark Mode → heller
        newR = Math.min(255, r + amount);
        newG = Math.min(255, g + amount);
        newB = Math.min(255, b + amount);
        }

        return `rgb(${newR}, ${newG}, ${newB})`;
    }
    }

}

export const lightTheme = {

  ...common,

  colors: {

    text: "#111827",
    heading: "#0f172a",

    background: "#f5f5f7",
    surface: "#ffffff",

    primary: "#1a6f1b",     // etwas gedeckteres, historisch-militärisches Grün
    secondary: "#6a3d1a",
    accent: "#fbbf24",
    // danger: "hsl(348, 100%, 61%)",
    danger: "#df0e0e",
    gray300: "#94a3b8",
    gray500: "#6b7280",
    gray700: "#374151",

    border: "#e5e7eb"

  }

}

export const darkTheme = {

  ...common,

  colors: {

    // Textfarben
    text: "#f8fafc",        // fast weiß, klar lesbar
    heading: "#f8fafc",     // identisch für Einheitlichkeit
    
    // Hintergrund
    background: "#0b1120",  // sehr dunkles Blau-Schwarz
    surface: "#111827",

    // Primär- und Sekundärfarben
    primary: "#1a6f1b",     // etwas gedeckteres, historisch-militärisches Grün
    secondary: "#6a3d1a",   // dunkleres, harmonisches Braun (Bundesheer-Ton)

    // Akzent
    accent: "#e0b33c",      // warmes, gedämpftes Gelb für Highlights, weniger grell
    // danger: "hsl(348, 100%, 61%)",
    danger: "#df0e0e",
    // Grautöne für Text und UI-Elemente
    gray300: "rgba(255,255,255,0.15)", 
    gray500: "#9ca3af",
    gray700: "#d1d5db",

    // Grenzen / Linien
    border: "#2a2d36"

  },

  shadow: {
    xs: "0 1px 2px rgba(0,0,0,0.4)",
    sm: "0 4px 12px rgba(0,0,0,0.5)",
    md: "0 10px 30px rgba(0,0,0,0.6)",
    lg: "0 20px 60px rgba(0,0,0,0.7)"
  },

}